import { Scadenza } from '../../../models/scadenza';


export class ScadenzaAdapter {

  scadenza: Scadenza = new Scadenza();
/*
  id: string;
  tipoScadenza: TipoScadenza;
  motivo: MotivoScadenza;
  priorita: Priorita;
  dataScadenza: number;
  dataPromemoria: number;
  pubblica: boolean;
  evasa: boolean;
  dataEvasione: number;
  appunto: string;
  note: string;
  rinvioScadenza: Array<any>;
  documenti: DocumentoAllegato[];*/

  constructor(scadenza: Scadenza) {
    this.scadenza.id = scadenza.id;
    this.scadenza.tipoScadenza = scadenza.tipoScadenza ? JSON.parse(JSON.stringify(scadenza.tipoScadenza)) : null;
    this.scadenza.motivo = scadenza.motivo ? JSON.parse(JSON.stringify(scadenza.motivo)) : null;
    this.scadenza.motivoEvasione = scadenza.motivoEvasione ? JSON.parse(JSON.stringify(scadenza.motivoEvasione)) : null;
    this.scadenza.priorita = scadenza.priorita ? JSON.parse(JSON.stringify(scadenza.priorita)) : null;
    this.scadenza.dataScadenza = scadenza.dataScadenza;
    this.scadenza.dataPromemoria = scadenza.dataPromemoria;
    this.scadenza.pubblica = scadenza.pubblica ? scadenza.pubblica : false ;
    this.scadenza.evasa = scadenza.evasa ? scadenza.evasa : false ;
    this.scadenza.dataEvasione = scadenza.dataEvasione;
    this.scadenza.appunto = scadenza.appunto;
    this.scadenza.note = scadenza.note;
    this.scadenza.documenti = scadenza.documenti;
    this.scadenza.assegnatario = scadenza.assegnatario ? scadenza.assegnatario : null;
    this.scadenza.dettaglioEsitoAdempimento = scadenza.dettaglioEsitoAdempimento ? scadenza.dettaglioEsitoAdempimento : null;
  }
}
